import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { ProfileService } from '../../services/profile.service';
import {
  getPaperlessActions,
  getProfileEmailActions,
  getProfileResidenceActions,
  getProfileResidenceFailureActions,
  getProfileResidenceSuccessActions,
} from '../actions/profile.actions';
import {
  selectProfileEmail,
  selectProfilePaperless,
  selectProfileResidenceResponse,
} from '../selectors/profile.selectors';
import { ApiEffects } from '../../../../utils/effects.util';

@Injectable()
export class ProfileEffects extends ApiEffects {
  constructor(
    readonly actions$: Actions,
    private readonly profileService: ProfileService,
    private readonly store: Store
  ) {
    super(actions$);
  }

  getProfileResidence$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getProfileResidenceActions),
      withLatestFrom(this.store.select(selectProfileResidenceResponse)),
      switchMap(([action, cachedRes]) => {
        if (cachedRes) {
          return of(getProfileResidenceSuccessActions({ data: cachedRes }));
        }
        return this.profileService.getResidenceInfo().pipe(
          take(1),
          map((data) => getProfileResidenceSuccessActions({ data })),
          catchError((error) => of(getProfileResidenceFailureActions({ error })))
        );
      })
    );
  });

  getProfilePaperless$ = this.createCachedApiEffect({
    actions: getPaperlessActions,
    effectFn: (customerId) => this.profileService.getProfilePaperless(customerId),
    cachedObservable: this.store.select(selectProfilePaperless),
  });

  getProfileEmail$ = this.createCachedApiEffect({
    actions: getProfileEmailActions,
    effectFn: (request) => this.profileService.getProfileEmail(request),
    cachedObservable: this.store.select(selectProfileEmail),
  });
}
